import BallotIcon from "@mui/icons-material/Ballot";

// Market Place React views

import RTL from "views/rtl";
// import Profile from "views/authentication/profile";
import SignIn from "views/authentication/sign-in";
// import SignUp from "views/authentication/sign-up";

import TitleView from "views/mainScreen/TitleView";
import CapsuleView from "views/mainScreen/CapsuleView";
import PageView from "views/mainScreen/PageView";
import PageQuestions from "views/pagequestions/PageQuestions";
import CondtionView from "views/conditions/CondtionView";
import ReportView from "views/report/Report";
import UserView from "views/usres/index";
import OutUsersView from "views/usres/outUsers";
import FilesAccess from "views/files/fileAccess";
import PagesAccess from "views/pages/pageAccess";
 
 
const routes = [
  {
    type: "collapse",
    sidebar: false,
    name: "TitleView",
    key: "TitleView",
    icon: <BallotIcon />,
    route: "/mainscreen/:headline",
    component: <TitleView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "FilesAccess",
    key: "FilesAccess",
    icon: <BallotIcon />,
    route: "/files/fileaccess",
    component: <FilesAccess />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "PagesAccess",
    key: "PagesAccess",
    icon: <BallotIcon />,
    route: "/pages/pageaccess",
    component: <PagesAccess />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "OutUsersView",
    key: "OutUsersView",
    icon: <BallotIcon />,
    route: "/outusers/:headline/:title/:capsule/:capsuletitle",
    component: <OutUsersView />,
    
  },
  
  {
    type: "collapse",
    sidebar: false,
    name: "Report",
    key: "Report",
    route: "/report/:headline/:capsule",
    icon: <BallotIcon />,
    component: <ReportView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "UserView",
    key: "UserView",
    route: "/users",
    icon: <BallotIcon />,
    component: <UserView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "CapsuleView",
    key: "CapsuleView",
    icon: <BallotIcon />,
    route: "/clinic/:headline/:title",
    component: <CapsuleView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "PageView",
    key: "PageView",
    icon: <BallotIcon />,
    route: "/page/:headline/:title/:capsule",
    component: <PageView />,
  },

  {
    type: "collapse",
    sidebar: false,
    name: "CondtionView",
    key: "CondtionView",
    icon: <BallotIcon />,
    route: "/condition/:headline/:title/:capsule/:form/:page/:type/:formType",
    component: <CondtionView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "CondtionView",
    key: "CondtionView",
    icon: <BallotIcon />,
    route:
      "/condition/:headline/:title/:capsule/:form/:page/:type/:formType/:question",
    component: <CondtionView />,
  },
  {
    type: "collapse",
    sidebar: false,
    name: "PageQuestions",
    key: "PageQuestions",
    icon: <BallotIcon />,
    route: "/pagequestions/:headline/:title/:capsule/:form/:page/:formTyp",
    component: <PageQuestions />,
  },
  {
    type: "collapse",
    sidebar: true,
    name: "RTL",
    key: "rtl",
    icon: <BallotIcon />,
    route: "/rtl",
    component: <RTL />,
  },
  // {
  //   type: "collapse",
  //   sidebar: true,
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <BallotIcon />,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   sidebar: true,
  //   name: "Profile",
  //   key: "profile",
  //   icon: <BallotIcon />,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    sidebar: true,
    name: "Sign In",
    key: "sign-in",
    icon: <BallotIcon />,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  // {
  //   type: "collapse",
  //   sidebar: true,
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <BallotIcon />,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];
export default routes;
